import { render, staticRenderFns } from "./tag-input.vue?vue&type=template&id=25a58aca&"
import script from "./tag-input.vue?vue&type=script&lang=js&"
export * from "./tag-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports